import { filter } from 'src/types';
import {
  PIPELINE_DROP, PIPELINE_SET_APPLY, PIPELINE_TOGGLE_APPLY,
  PIPELINE_TOGGLE_FIELDS_LIST, PIPELINE_TOGGLE_SAVED_LIST,
  PIPELINE_ADD_PIPE, PIPELINE_DELETE_PIPE, PIPELINE_MOVE_PIPE,
  PIPELINE_SET_PIPE_TYPE, PIPELINE_SET_PIPE_LOGIC, PIPELINE_SET_PIPES,
  PIPELINE_ADD_FIELD, PIPELINE_DELETE_FIELD, PIPELINE_MOVE_FIELD,
  PIPELINE_SET_FIELD_IS, PIPELINE_SET_FIELD_TYPE, PIPELINE_SET_FIELD_CLAUSE,
  PIPELINE_SET_FIELD_SORT, PIPELINE_ADD_GROUP, PIPELINE_SET_PROGRESS,
  PIPELINE_SAVE, PIPELINE_SET,
} from './types';

export const drop = () => ({
  type: PIPELINE_DROP,
});

export const setApply = applied => ({
  type: PIPELINE_SET_APPLY,
  applied,
});

export const toggleApply = () => ({
  type: PIPELINE_TOGGLE_APPLY,
});

export const toggleFieldsList = () => ({
  type: PIPELINE_TOGGLE_FIELDS_LIST,
});

export const toggleSavedList = () => ({
  type: PIPELINE_TOGGLE_SAVED_LIST,
});

export const addPipe = (pipeType, fields) => ({
  type: PIPELINE_ADD_PIPE,
  pipeType, fields,
});

export const deletePipe = pipeId => ({
  type: PIPELINE_DELETE_PIPE,
  pipeId,
});

export const movePipe = (pipeId, destinationId) => ({
  type: PIPELINE_MOVE_PIPE,
  pipeId, destinationId,
});

export const setPipeType = (pipeId, pipeType) => ({
  type: PIPELINE_SET_PIPE_TYPE,
  pipeId, pipeType
});

export const setPipeLogic = (pipeId, pipeLogic) => ({
  type: PIPELINE_SET_PIPE_LOGIC,
  pipeId, pipeLogic
});

export const setPipes = pipes => ({
  type: PIPELINE_SET_PIPES,
  pipes,
});

export const addField = (field, pipeId, index = -1) => {
  // old behavior for SELECTOR fields
  // const values = devicesIndex[fields[field].name];
  // const compareType = values && values.length > 0 ? filter.TYPE.EQUAL : filter.TYPE.CONTAINS;
  // const compareType = filter.TYPE.CONTAINS;

  return ({
    type: PIPELINE_ADD_FIELD,
    field, pipeId, index, // compareType,
  });
};

export const deleteField = (pipeId, fieldId) => ({
  type: PIPELINE_DELETE_FIELD,
  pipeId, fieldId,
});

export const moveField = (sourcePipeId, fieldId, destinationPipeId, destinationId) => ({
  type: PIPELINE_MOVE_FIELD,
  sourcePipeId, fieldId, destinationPipeId, destinationId,
});

export const setFieldIs = (pipeId, fieldId, is) => ({
  type: PIPELINE_SET_FIELD_IS,
  pipeId, fieldId, is,
});

export const setFieldType = (pipeId, fieldId, fieldType) => ({
  type: PIPELINE_SET_FIELD_TYPE,
  pipeId, fieldId, fieldType,
});

export const setFieldClause = (pipeId, fieldId, clause) => ({
  type: PIPELINE_SET_FIELD_CLAUSE,
  pipeId, fieldId, clause,
});

export const setFieldSort = (pipeId, fieldId, sort) => ({
  type: PIPELINE_SET_FIELD_SORT,
  pipeId, fieldId, sort,
});

export const addGroup = pipeId => ({
  type: PIPELINE_ADD_GROUP,
  pipeId
});

export const setProgress = (percent, pipe = null) => ({
  type: PIPELINE_SET_PROGRESS,
  percent, pipe,
});

export const setPipeline = payload => ({
  type: PIPELINE_SET,
  payload,
});
